module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-8293006a5857609921fbd471057f849d.webp";